/******* POPUP *******/
if (!window.__QUICK_ADD_POPUP_INIT__) {
window.__QUICK_ADD_POPUP_INIT__ = true;
let quickAddPopupScrollbarWidth = window.innerWidth - document.body.offsetWidth;
window.addEventListener('resize', () => {
  quickAddPopupScrollbarWidth = window.innerWidth - document.body.offsetWidth;
}, true);

function quickAddPopup() {
  const settings = {
    speedOpen: 50,
    speedClose: 150,
    activeClass: "is-active",
    visibleClass: "_is-visible",
    selectorTarget: "[data-modal-target]",
    selectorTrigger: "[data-modal-trigger]",
    selectorClose: "[data-modal-close]",
  };

  let savedScrollPosition = 0;
  let headerWasHidden = false;
  let quickAddReturnFocus = null;

  const activeModal = function () {
    return document.querySelector(settings.selectorTarget + "." + settings.activeClass);
  };

  const modalFocusable = function (target) {
    return Array.from(target.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((el) => !el.disabled && el.offsetParent !== null);
  };

  // Focus the dialog itself, not the close button: opening by mouse then shows no ring,
  // while the first Tab still lands on the close button and does show one.
  const focusIntoModal = function (target) {
    const dialog = target.querySelector(".quick-add-popup__content") || target;
    if (!dialog.hasAttribute("tabindex")) dialog.setAttribute("tabindex", "-1");
    dialog.focus();
  };

  const restoreTriggerFocus = function () {
    if (quickAddReturnFocus && document.contains(quickAddReturnFocus)) {
      quickAddReturnFocus.focus();
    }
    quickAddReturnFocus = null;
  };

  const saveScrollState = function () {
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const headerWrapper = document.querySelector('.header-wrapper');
    headerWasHidden = headerWrapper ? headerWrapper.classList.contains('hidden') : false;

    if (window.innerWidth <= 767) {
      document.body.style.top = `-${savedScrollPosition}px`;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }
  };

  const restoreScrollState = function () {

    if (window.innerWidth <= 767) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
    }
    window.scrollTo(0, savedScrollPosition);
    requestAnimationFrame(() => {
      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) {
        if (headerWasHidden) {
          headerWrapper.classList.add('hidden');
        } else {
          headerWrapper.classList.remove('hidden');
        }
      }
    });
  };

  const toggleAccessibility = function (event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  const openModal = function (trigger) {
    saveScrollState();
    const target = document.getElementById(trigger.getAttribute("data-modal-trigger"));
    target.classList.add(settings.activeClass);
    document.documentElement.classList.add('_popup-opened');
    toggleAccessibility(trigger);
    document.querySelector("html").style.paddingRight = quickAddPopupScrollbarWidth + "px";
    quickAddReturnFocus = trigger;
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
      focusIntoModal(target);
    }, settings.speedOpen);
  };

  const closeModal = function (event) {
    const closestParent = event.closest(settings.selectorTarget);
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.classList.remove('_popup-opened');
    document.querySelector('html').style.paddingRight = '0px';
    restoreScrollState();
    restoreTriggerFocus();
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  const clickHandler = function (event) {
    const toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    if (open) {
      openModal(open);
    }
    if (close) {
      closeModal(close);
    }
    if (open || close) {
      event.preventDefault();
    }
  };

  const keydownHandler = function (event) {
    if (event.key === "Tab") {
      const target = activeModal();
      if (target) {
        const focusable = modalFocusable(target);
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
      return;
    }
    if (event.key === "Escape" || event.keyCode === 27) {
      let modals = document.querySelectorAll(settings.selectorTarget);
      for (let i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }
    }
  };

  window.showModal = function (modalName, trigger) {
    saveScrollState();
    if (trigger) quickAddReturnFocus = trigger;
    let target = document.getElementById(modalName);
    target.classList.add(settings.activeClass);
    target.setAttribute('aria-expanded', true);
    document.documentElement.classList.add('_popup-opened');
    document.querySelector("html").style.paddingRight = quickAddPopupScrollbarWidth + "px";
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
      focusIntoModal(target);
    }, settings.speedOpen);
  };

  window.hideModal = function (modalName) {
    let target = document.getElementById(modalName);
    target.classList.remove(settings.visibleClass);
    target.setAttribute('aria-expanded', false);
    document.documentElement.classList.remove('_popup-opened');
    document.querySelector("html").style.paddingRight = "0px";
    restoreScrollState();
    restoreTriggerFocus();
    setTimeout(function () {
      target.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
}

quickAddPopup();
/******* END POPUP *******/


/******* PRICE FORMAT *******/
const formatPrice = (price) => {
  if (typeof price === 'string') {
    price = Number(price);
  }
  if (isNaN(price)) {
    return '$0';
  }
  return '$' + Math.floor(price);
};

const isVariantVisibleByActiveMetafield = (variant) => {
  const activeRaw = variant?.active?.value ?? variant?.metafield?.value;
  if (activeRaw === null || activeRaw === undefined || activeRaw === '') {
    return true;
  }

  const normalized = String(activeRaw).trim().toLowerCase();
  if (normalized === 'false' || normalized === '0') {
    return false;
  }

  return normalized === 'true' || normalized === '1';
};

const isVariantSelectable = (variant) => !!variant && variant.availableForSale && isVariantVisibleByActiveMetafield(variant);

const getVariantPriceAmount = (variant) => {
  if (!variant) return 0;

  if (typeof variant.price === 'number') {
    return variant.price / 100;
  }

  const amount = Number(variant.price?.amount);
  return Number.isFinite(amount) ? amount : 0;
};

const getVariantCompareAtAmount = (variant) => {
  if (!variant) return 0;

  if (typeof variant.compare_at_price === 'number') {
    return variant.compare_at_price / 100;
  }

  const amount = Number(variant.compareAtPrice?.amount);
  return Number.isFinite(amount) ? amount : 0;
};

const isVariantAvailableForInitialState = (variant) => {
  if (!variant) return false;
  if (typeof variant.availableForSale === 'boolean') {
    return variant.availableForSale && isVariantVisibleByActiveMetafield(variant);
  }
  return !!variant.available;
};
/******* END PRICE FORMAT *******/


/******* QUICK ADD POPUP INIT *******/
const quickAddPopupInit = async (btn) => {
  const productId = btn.getAttribute('data-product-id');
  let productJsonElement = document.getElementById(`quick-add-product-data-${productId}`);

  // JSON not injected yet by product-card-grid.js — fetch on demand via AJAX
  if (!productJsonElement) {
    const card = btn.closest('.item-product') || btn.closest(`[id="product-${productId}"]`);
    const cardLink = card ? card.querySelector('a.product-card-link, a[href*="/products/"]') : null;
    const hrefPath = cardLink ? (cardLink.getAttribute('href') || '') : '';
    const handleMatch = hrefPath.match(/\/products\/([^?#/]+)/);
    const handle = handleMatch ? handleMatch[1] : null;
    if (handle) {
      try {
        const res = await fetch(`/products/${handle}.json`);
        if (res.ok) {
          const { product: p } = await res.json();
          const availableVariant = p.variants.find(v => v.available) || p.variants[0] || null;
          const script = document.createElement('script');
          script.type = 'application/json';
          script.id = `quick-add-product-data-${productId}`;
          // Normalize options: REST API returns [{id,name,...}], code expects ["Size","Color",...]
          const normalizedOptions = (p.options || []).map(o => (typeof o === 'string' ? o : (o.name || '')));
          script.textContent = JSON.stringify({
            product: { ...p, options: normalizedOptions },
            selected_or_first_available_variant: availableVariant,
            variants_inventory: p.variants.map(v => ({ id: v.id, inventory_quantity: v.inventory_quantity || 0 }))
          });
          document.body.appendChild(script);
          productJsonElement = script;
        }
      } catch (e) {}
    }
  }

  const productData = productJsonElement ? JSON.parse(productJsonElement.innerHTML) : null;
  const product = productData ? productData.product : null;
  let selectedVariant = productData ? productData.selected_or_first_available_variant : null;
  const requestedVariantId = btn.getAttribute('data-current-variant-id') || btn.closest('[data-current-variant-id]')?.getAttribute('data-current-variant-id') || '';
  
  // Check if this is from Complete The Look section - use current variant
  const completeTheLookItem = btn.closest('[data-current-variant-id]');
  if (completeTheLookItem && product) {
    const currentVariantId = completeTheLookItem.getAttribute('data-current-variant-id');
    if (currentVariantId) {
      const matchingVariant = product.variants.find(v => v.id == currentVariantId);
      if (matchingVariant) {
        selectedVariant = matchingVariant;
      }
    }
  }
  
  const variantsInventory = productData ? productData.variants_inventory : [];
  const variants = product ? product.variants : null;
  const popup = document.getElementById('quick-add-popup');
  const popupContent = popup ? popup.querySelector('.quick-add-popup__pdp') : null;

  if (!product || !selectedVariant || !popup || !popupContent) return;

  // Set per open: only cards from sections with the setting on swap the side cart for "Added to bag"
  popup.dataset.showAddedPopup = btn.closest('[data-quick-add-added-popup]') ? 'true' : 'false';

  const isQuickAddBisEnabled = popup.dataset.bisEnabled === 'true';
  const bisFormId = popup.dataset.bisFormId || '';
  let colorOption = selectedVariant.option2 || selectedVariant.selectedOptions?.find(o => o.name === 'Color')?.value || '';
  const containSizeOption = product.options ? product.options.find(option => option.toLowerCase() === 'size') : null;
  const containColorOption = product.options ? product.options.find(option => option.toLowerCase() === 'color') : null;
  const valuesOptionIndex = product.options ? product.options.findIndex(option => option.toLowerCase() === 'values') : -1;
  const containValuesOption = valuesOptionIndex >= 0;
  const sizeBtnLabel = popup.getAttribute('data-product-size-label') || 'Select A Size';
  const sizeErrorLabel = popup.getAttribute('data-product-error-label');
  const errorBackgroundColor = popup.getAttribute('data-error-background-color');
  const errorTextColor = popup.getAttribute('data-error-text-color');
  const showQtySelector = popup.getAttribute('data-show-qty-selector') === 'true';
  const sizeErrorHideUntilClick = popup.getAttribute('data-size-error-hide-until-click') === 'true';
  const isSizesSwiperEnabled = popup.getAttribute('data-sizes-swiper-enabled') === 'true';
  const progressiveSaleLabel = popup.getAttribute('data-progressive-sale-label') || 'buy & save';
  const showProgressiveSaleBadge = popup.getAttribute('data-show-progressive-sale-badge') === 'true';
  const showSaleBadge = popup.getAttribute('data-show-sale-badge') === 'true';
  const saleBadgeHTML = Object.assign(document.createElement('span'), {
    className: 'option-color__badge option-color__badge--sale color-badge-sale',
    textContent: popup.getAttribute('data-sale-badge-text') || 'sale'
  }).outerHTML;
  const saleRank = { first: -2, default: 0 }[popup.getAttribute('data-sale-badge-order')] ?? 2;

  btn.classList.add('loading');

  const handle = product.handle;
  if (!handle) return;
  const STOREFRONT_TOKEN = ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407');
  const SHOP_DOMAIN = ((window.LIVE && window.LIVE.shopDomain) || 'live-ecom.myshopify.com');

  async function fetchAllVariants(handle) {
        let all = [];
        let cursor = null;
        let hasNext = true;

        while (hasNext) {
        const query = `
            query ($handle: String!, $cursor: String) {
            product(handle: $handle) {
                variants(first: 250, after: $cursor) {
                edges {
                    cursor
                    node {
                    id
                    sku
                    availableForSale
                    selectedOptions {
                        name
                        value
                    }
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    active: metafield(namespace: "custom", key: "active") {
                      value
                    }
                    progressiveSale: metafield(namespace: "custom", key: "progressive_sale") {
                      value
                    }
                    images: metafield(namespace: "custom", key: "images") {
                      references(first: 20) {
                        edges {
                          node {
                            ... on MediaImage {
                              image {
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                pageInfo {
                    hasNextPage
                }
              }
            }
          }
        `;

        const res = await fetch(
            `https://${SHOP_DOMAIN}/api/2025-07/graphql.json`,
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({
                query,
                variables: { handle, cursor }
            })
            }
        );

        const json = await res.json();
        const variants = json.data.product.variants;
        variants.edges.forEach(edge => {
            all.push(edge.node);
            cursor = edge.cursor;
        });

        hasNext = variants.pageInfo.hasNextPage;
        }
        return all;
  }

  const cachedVariants = window.__quickAddVariantsCache?.[handle];
  const allVariants = cachedVariants ? Promise.resolve(cachedVariants) : fetchAllVariants(handle);
  const colorsMap = {};

  const allVars = await allVariants;
  
  var sequence = 0; 
  allVars.forEach(variant => {
    const color = variant.selectedOptions.find(o => o.name === 'Color')?.value;
    if (!color) return;
    const urls = variant.images?.references?.edges?.map(e => e.node.image.url) ?? [];

    if (!colorsMap[color]) {
      colorsMap[color] = {
        available: false,
        visible: false,
        sequence: sequence++,
        images: []
      };
    }
    const colorData = colorsMap[color];
    if (variant.active?.value === 'true') {
      colorData.visible = true;
    }
    if (variant.availableForSale) {
      colorData.available = true;
    }
    if (urls.length) {
      colorData.images = urls;
    }
  });

  var hasSelectedImage = false;

  async function buildImagesHTML2 ({ colorsMap, product }) {
    const imagesTags = [];
    const normalizedInitialColor = String(colorOption || '').trim().toLowerCase();
    Object.entries(colorsMap).sort(([, a], [, b]) => a.sequence - b.sequence).forEach(([color, meta]) => {        
      var isCurrent = '';

      if (String(color).trim().toLowerCase() === normalizedInitialColor) {
        if (meta.visible && meta.available){
          hasSelectedImage = true;
          isCurrent = 'active';
        }          
      }    
        
      meta.images.sort((a, b) => a.sequence - b.sequence).forEach((image, index) => {   
        const imageTag = `
          <div class="main-image-slide image-slide swiper-slide${isCurrent == 'active' ? '' : ' hidde-image-main-to-show'}"> 
            <img src="${image}" alt="${(product.title || 'Product image').replace(/["]/g, '&quot;')}" width="375" height="457" loading="lazy" />
          </div>
        `;        
        imagesTags.push(imageTag);
      });        
    });
    return imagesTags.join('');
  }
  async function buildColorsHTML({ allVariants, product }) {
    const variants2 = await allVariants;
    const onlyVariants = variants2.flat();
    const colorOption = product.options.find(opt => opt === 'Color');
    if (!colorOption) return '';
    const colorBaseUrl = "https://imagens.liveoficial.com.br/color-sku/";
    const colorValues = [
      ...new Set(
        onlyVariants
          .filter(v => isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield(v) : isVariantSelectable(v))
          .map(v => v.selectedOptions.find(o => o.name === 'Color')?.value)
          .filter(Boolean)
      )
    ];

    const badgeNew = window.ColorBadgeNew;
    const swatches = [];

    colorValues.forEach(colorValue => {
      // All variants of this color, regardless of availability — badges mirror PDP logic
      const allVariantsByColor = onlyVariants.filter(v =>
        v.selectedOptions.find(o => o.name === 'Color')?.value === colorValue
      );
      const variantsByColor = allVariantsByColor.filter(v =>
        isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield(v) : isVariantSelectable(v)
      );

      if (!variantsByColor.length) {
        return;
      }

      const hasSale = allVariantsByColor.some(v =>
        v.compareAtPrice &&
        Number(v.compareAtPrice.amount) > Number(v.price.amount)
      );
      const hasProgressiveSale = allVariantsByColor.some(v => v.progressiveSale?.value === 'true');
      const hasBadge = hasSale || hasProgressiveSale;
      const isNew = !!badgeNew && badgeNew.matches(colorValue);
      let badgeHTML = (hasProgressiveSale && showProgressiveSaleBadge)
        ? `<span class="option-color__badge option-color__badge--progressive color-badge-sale color-badge-sale--progressive">${progressiveSaleLabel}</span>`
        : (hasSale && showSaleBadge)
          ? saleBadgeHTML
          : '';
      const newLabel = isNew ? badgeNew.label(badgeHTML) : '';
      if (isNew) badgeHTML = badgeNew.badgeHtml(badgeHTML);

      const colorUrl = `${colorBaseUrl}${colorValue}.png`;
      const colorDiv = `
        <div
          data-option-type="color"
          style="background-image: url(${colorUrl})"
          role="button"
          tabindex="0"
          class="option-color color-value-${colorValue.toLowerCase()} ${hasBadge ? 'sale' : ''}"
          data-val="${colorValue.toLowerCase()}"
          data-prod-id="${product.id}"
          aria-label="Color: ${colorValue}${newLabel ? `, ${badgeNew.escapeHtml(newLabel)}` : ''}">
          ${badgeHTML}
        </div>
      `;
      // Sort by the badge actually shown: no badge (0), then "buy & save" (1); Sale and New colors move per theme settings
      const rank = (hasProgressiveSale && showProgressiveSaleBadge) ? 1 : (hasSale ? saleRank : 0);
      swatches.push({ rank: isNew ? badgeNew.rank(rank, saleRank) : rank, html: colorDiv });
    });

    return swatches.sort((a, b) => a.rank - b.rank).map(swatch => swatch.html).join('');
  }
  async function buildImagesHTML ({ allVariants, product }) {
    const variants2 = await allVariants;
    const onlyVariants = variants2.flat();
    const colorValues = [
      ...new Set(
        onlyVariants
          .filter(v => isVariantSelectable(v))
          .map(v => v.selectedOptions.find(o => o.name === 'Color')?.value)
          .filter(Boolean)
      )
    ];
    const imagesTags = [];
    colorValues.forEach(colorValue => {
      const variantsByColor = onlyVariants.filter(v =>
        v.selectedOptions.find(o => o.name === 'Color')?.value === colorValue && isVariantSelectable(v)
      );
      if (!variantsByColor.length) {
        return;
      }
      if (variantsByColor[0].active.value == 'true' && variantsByColor[0].availableForSale) {
        const images = variantsByColor[0].images?.references?.edges;
        if (images && images.length > 0) {
          images.forEach(image => {
            const imageTag = `
              <div class="main-image-slide image-slide swiper-slide${colorOption && !image.node?.image?.url?.includes(colorOption) ? ' hidde-image-main-to-show' : ''}"> 
                <img src="${image.node?.image?.url}" alt="${(product.title || 'Product image').replace(/["]/g, '&quot;')}" width="375" height="457" loading="lazy" />
              </div>
            `;
            imagesTags.push(imageTag);
          });
        }
      }
    });
    return imagesTags.join('');
  }

  const graphqlVariants = await allVariants;

  if (requestedVariantId) {
    const requestedVariantNumericId = String(requestedVariantId).split('/').pop();
    const requestedVariant = graphqlVariants.find(variant => {
      const variantId = String(variant.id || '').split('/').pop();
      return variantId && requestedVariantNumericId && variantId === requestedVariantNumericId;
    });

    if (requestedVariant) {
      selectedVariant = requestedVariant;
      colorOption = requestedVariant.selectedOptions?.find(o => o.name === 'Color')?.value || colorOption;
    }
  }

  if (!isVariantSelectable(selectedVariant)) {
    const selectedVariantId = String(selectedVariant?.id || '').split('/').pop();
    const selectableVariant = graphqlVariants.find(variant => {
      const variantId = String(variant.id || '').split('/').pop();
      return variantId && selectedVariantId && variantId === selectedVariantId && isVariantSelectable(variant);
    }) || graphqlVariants.find(isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield : isVariantSelectable);

    if (selectableVariant) {
      selectedVariant = selectableVariant;
      colorOption = selectableVariant.selectedOptions?.find(o => o.name === 'Color')?.value || colorOption;
    }
  }

  const colorsHTML = await buildColorsHTML({ allVariants, product });
  const imageHTML = await buildImagesHTML2({ colorsMap, product });
  
  const galleryHTML = `
    <div class="quick-add-popup__pdp-gallery">
      <div class="swiper product-main-slider">
        <div class="swiper-main-image-content main-image-content swiper-wrapper">
            ${imageHTML != '' ? imageHTML : 
              product.media.map(image => {
                if(image.src){
                  const imageSrc = image.src.includes('?') ? image.src + '&width=750' : image.src + '?width=750';
                  
                  return `
                    <div class="main-image-slide image-slide swiper-slide${colorOption && !image.src.includes(colorOption) ? ' hidde-image-main-to-show' : ''}">
                      <img src="${imageSrc}" alt="${(image.alt || product.title || 'Product image').replace(/["]/g, '&quot;')}" width="375" height="457" loading="lazy" />
                    </div>`
                  }
              }).join('')
            }
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M16.495 21L7.5 11.973L16.5 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="swiper-button-next">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M7.505 3L16.5 12.027L7.5 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
  </div>`;

  const detailsHTML = `
    <div class="quick-add-popup__pdp-details">
      <a href="/products/${product.handle}" class="quick-add-popup__pdp-link quick-add-popup__pdp-link--mobile">View Full Details</a>
      <h2 class="quick-add-popup__pdp-title">${product.title}</h2>
      <div class="quick-add-popup__pdp-price product__price">
        <span class="quick-add-popup__pdp-price-price money">
          ${formatPrice(getVariantPriceAmount(selectedVariant))}
        </span> 
        ${getVariantPriceAmount(selectedVariant) < getVariantCompareAtAmount(selectedVariant) ? `
          <s class="quick-add-popup__pdp-price-compare-at money">
            ${formatPrice(getVariantCompareAtAmount(selectedVariant))}
          </s>
        ` : ''}
      </div>
    </div>`;

  const formHTML = `
    <div class="quick-add-popup__pdp-form product-form">
      <form action="/cart/add" method="post" enctype="multipart/form-data" id="AddToCartForm">
        <meta itemprop="price" content="${formatPrice(product.price)}">

        ${(variants.length > 1 || colorsHTML) ? `
          <div class="product-variants" data-handle="${product.handle}">
            ${containColorOption ? `
              <div class="wrapper-color">
                <div class="color-core color-limited">
                  <span class="color-title-wrapper">Color: <span class="color-title core-color-title limited-color-title"></span></span>
                  <div class="colors">
                    ${colorsHTML}
                  </div>
                </div>
              </div>
            ` : ''}

            <select name="id" id="productSelect" class="product-single__variants block">
              ${graphqlVariants.map(variant => `
                ${(isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield(variant) : isVariantSelectable(variant)) ? `
                  <option ${variant.id === selectedVariant.id ? 'selected="selected"' : ''} data-sku="${variant.sku}" value="${variant.id}">${variant.title} - ${formatPrice(variant.price.amount)}</option>
                ` : `
                  <option disabled="disabled">${variant.title} - Sold Out</option>
                `}
              `).join('')}
            </select>

            ${containSizeOption ? `
              <div class="selector-wrapper size" data-option-index="1" id="size-selector-wrapper--popup">
                <label for="SingleOptionSelector-0">Size</label>
                <select class="single-option-selector" id="SingleOptionSelector-0" data-index="option1">
                  ${(() => {
                    const graphQlSizeValues = [...new Set(graphqlVariants.map(v => v.selectedOptions.find(o => o.name === 'Size')?.value).filter(Boolean))];
                    const productSizeValues = [...new Set((product.variants || []).map(v => v.option1).filter(Boolean))];
                    const sizeValues = productSizeValues.filter(size => graphQlSizeValues.includes(size)).concat(
                      graphQlSizeValues.filter(size => !productSizeValues.includes(size))
                    );
                    
                    return sizeValues.map(size => {
                      const hasAvailableVariants = graphqlVariants.some(v => 
                        v.selectedOptions.find(o => o.name === 'Size')?.value === size && (isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield(v) : isVariantSelectable(v))
                      );
                  
                      if (hasAvailableVariants) {
                        return `<option value="${size}">${size}</option>`;
                      } else {
                        return `<option value="${size}" disabled="disabled">${size}</option>`;
                      }
                    }).join('');
                  })()}
                </select>
              </div>
            ` : ''}

            ${containValuesOption ? `
              <div class="selector-wrapper values" data-option-index="${valuesOptionIndex + 1}" id="values-selector-wrapper--popup">
                <label for="SingleOptionSelector-values">Amount</label>
                <select class="single-option-selector" id="SingleOptionSelector-values" data-index="option${valuesOptionIndex + 1}">
                  ${(() => {
                    const graphQlValues = [...new Set(graphqlVariants.map(v => v.selectedOptions.find(o => o.name === 'Values')?.value).filter(Boolean))];
                    const productValues = [...new Set((product.variants || []).map(v => v[`option${valuesOptionIndex + 1}`]).filter(Boolean))];
                    const optionValues = productValues.filter(value => graphQlValues.includes(value)).concat(
                      graphQlValues.filter(value => !productValues.includes(value))
                    );

                    return optionValues.map(value => {
                      const hasAvailableVariants = graphqlVariants.some(v =>
                        v.selectedOptions.find(o => o.name === 'Values')?.value === value && (isQuickAddBisEnabled ? isVariantVisibleByActiveMetafield(v) : isVariantSelectable(v))
                      );

                      return hasAvailableVariants
                        ? `<option value="${value}">${value}</option>`
                        : `<option value="${value}" disabled="disabled">${value}</option>`;
                    }).join('');
                  })()}
                </select>
              </div>
            ` : ''}

            <div style="display:none;">
              ${graphqlVariants.map(variant => `
                <div class="variant"
                    data-product-id="${product.id}"
                    data-variant-id="${variant.id}"
                    data-variant-available="${isVariantSelectable(variant)}"
                    data-variant-color="${variant?.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase()}"
                    data-variant-price="${variant.price.amount}"
                    data-variant-compare-at-price="${variant.compareAtPrice?.amount}">
                </div>
              `).join('')}
            </div>
          </div>
        ` : ``}
        <div id="product-buttons" class="btn-wrap product__btn-wrap">
          ${showQtySelector ? `<div class="ProductQty">
            <div class="Qty OptionBox OptionQty">
              <span class="down" role="button" tabindex="0" disabled="" aria-disabled="true" aria-label="Decrease quantity">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M4.03711 10H15.7038" stroke="currentColor" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <input type="number" id="Quantity" name="quantity" value="1" min="1" class="Quantity quantity-selector">
              <span class="up" role="button" tabindex="0" aria-label="Increase quantity">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M10 3.69788C10.2589 3.69788 10.4688 3.90774 10.4688 4.16663V9.53088H15.833C16.0916 9.53106 16.3016 9.74101 16.3018 9.99963C16.3018 10.2584 16.0917 10.4682 15.833 10.4684H10.4688V15.8336C10.4686 16.0924 10.2588 16.3024 10 16.3024C9.74122 16.3024 9.53142 16.0924 9.53125 15.8336V10.4684H4.16602C3.90713 10.4684 3.69727 10.2585 3.69727 9.99963C3.69744 9.7409 3.90724 9.53088 4.16602 9.53088H9.53125V4.16663C9.53125 3.90774 9.74112 3.69788 10 3.69788Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>` : ''}
          <button type="submit" name="add" id="AddToCart" class="btn dark fill ${(containSizeOption && variants.length > 1) || (variants.length == 1 && !selectedVariant.available) ? 'disabled' : ''}${!showQtySelector ? ' no-qty' : ''}">
            <span id="AddToCartText">${containSizeOption && variants.length > 1 ? sizeBtnLabel : variants.length == 1 && !selectedVariant.available ? 'Sold Out' : 'Add to Cart'}</span>
            <span id="AddToCartAdding">Adding...</span>
          </button>
          <div id="klaviyo-bis-button-container" style="display:none;">
            <button type="button" class="btn dark fill" data-klaviyo-bis-trigger>Notify me when back in stock</button>
          </div>
          ${sizeErrorLabel ? `<p class="size-error-message${errorBackgroundColor && errorBackgroundColor !== "rgba(0,0,0,0)" ? ' size-error-message--with-bg' : ''}" style="--background-color: ${errorBackgroundColor}; --text-color: ${errorTextColor};${sizeErrorHideUntilClick ? ' display:none;' : ''}">${sizeErrorLabel}</p>` : ''}
        </div>
        <p class="popup__cart-error" style="display: none;"></p>
      </form>
      <a href="/products/${product.handle}" class="quick-add-popup__pdp-link quick-add-popup__pdp-link--desktop">View Full Details</a>
    </div>`;

  if (window.__quickAddGallerySwiper__) {
    try { window.__quickAddGallerySwiper__.destroy(true, true); } catch (e) {}
    window.__quickAddGallerySwiper__ = null;
  }

  popupContent.innerHTML = galleryHTML + detailsHTML + formHTML;

  /* Gallery INIT */
  let swiper = new Swiper('.quick-add-popup__pdp-gallery .swiper', {
    speed: 400,
    spaceBetween: 6,
    slidesPerView: 1,
    preventClicks: false,
    preventClicksPropagation: false,
    touchStartPreventDefault: false,
    pagination: {
      el: '.quick-add-popup__pdp-gallery .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.quick-add-popup__pdp-gallery .swiper-button-next',
      prevEl: '.quick-add-popup__pdp-gallery .swiper-button-prev',
    },
  });
  window.__quickAddGallerySwiper__ = swiper;

  // APG tabs pattern: the dots are one tab stop and the arrow keys move between them,
  // instead of Swiper's default of making every bullet its own tab stop
  const setupPaginationKeyboard = function (instance, paginationEl) {
    if (!instance || !paginationEl) return;

    const bullets = function () {
      return Array.from(paginationEl.querySelectorAll('.swiper-pagination-bullet'));
    };

    const sync = function () {
      if (paginationEl.getAttribute('role') !== 'tablist') paginationEl.setAttribute('role', 'tablist');
      paginationEl.setAttribute('aria-label', 'Product images');
      bullets().forEach(function (bullet, i) {
        const selected = bullet.classList.contains('swiper-pagination-bullet-active');
        if (bullet.getAttribute('role') !== 'tab') bullet.setAttribute('role', 'tab');
        bullet.setAttribute('aria-label', 'Go to image ' + (i + 1));
        bullet.setAttribute('aria-selected', selected ? 'true' : 'false');
        bullet.setAttribute('tabindex', selected ? '0' : '-1');
      });
    };

    sync();
    instance.on('paginationRender', sync);
    instance.on('paginationUpdate', sync);
    instance.on('slideChange', sync);

    if (paginationEl.dataset.keyboardReady) return;
    paginationEl.dataset.keyboardReady = 'true';

    paginationEl.addEventListener('keydown', function (e) {
      const list = bullets();
      const current = list.indexOf(document.activeElement);
      if (current === -1) return;
      let next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % list.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + list.length) % list.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = list.length - 1;
      else return;
      e.preventDefault();
      instance.slideTo(next);
      const target = bullets()[next];
      if (target) {
        target.setAttribute('tabindex', '0');
        target.focus();
      }
    });
  };

  setupPaginationKeyboard(swiper, document.querySelector('.quick-add-popup__pdp-gallery .swiper-pagination'));

  /* Prevent text selection on button clicks */
  document.querySelectorAll('.quick-add-popup__pdp-gallery .swiper-button-prev, .quick-add-popup__pdp-gallery .swiper-button-next, .quick-add-popup .ProductQty .down, .quick-add-popup .ProductQty .up').forEach(btn => {
    btn.addEventListener('mousedown', (e) => e.preventDefault());
  });

  /* Prevent text selection on button clicks */
  document.querySelectorAll('.quick-add-popup__pdp-gallery .swiper-button-prev, .quick-add-popup__pdp-gallery .swiper-button-next, .quick-add-popup .ProductQty .down, .quick-add-popup .ProductQty .up').forEach(btn => {
    btn.addEventListener('mousedown', (e) => e.preventDefault());
  });

  /* Update gallery images based on color selection */
  const updateGalleryImages = (selectedColor) => {
    const $gallerySlides = document.querySelectorAll('.quick-add-popup__pdp-gallery .main-image-slide');
    let hasMatchingImages = false;

    $gallerySlides.forEach((slide, index) => {
      const slideImage = slide.querySelector('img');
      if (!slideImage) return;

      const imageSrc = slideImage.getAttribute('src') || slideImage.getAttribute('data-src');
      const imageContainsColor = imageSrc && imageSrc.toUpperCase().includes(selectedColor.replace(/^0+/, '').toUpperCase());

      if (imageContainsColor) {
        hasMatchingImages = true;
        slide.classList.add('active-image-main-to-show');
        slide.classList.remove('hidde-image-main-to-show');

        if (!slideImage.hasAttribute('src') && slideImage.hasAttribute('data-src')) {
          slideImage.setAttribute('src', slideImage.getAttribute('data-src'));
        }
      } else {
        slide.classList.add('hidde-image-main-to-show');
        slide.classList.remove('active-image-main-to-show');
      }
    });

    // If no images match the selected color, show only the first (main) image
    if (!hasMatchingImages && $gallerySlides.length > 0) {
      $gallerySlides.forEach((slide, index) => {
        if (index === 0) {
          slide.classList.add('active-image-main-to-show');
          slide.classList.remove('hidde-image-main-to-show');
        } else {
          slide.classList.add('hidde-image-main-to-show');
          slide.classList.remove('active-image-main-to-show');
        }
      });
    }

    if (swiper) {
      swiper.update();
      swiper.slideTo(0, 0);
    }
  };

  //Color swatch change
  const currentProductColor = colorOption.toLowerCase();

  document.querySelector('.quick-add-popup')?.addEventListener('click', function (e) {
    if (e.target.closest('.option-color')) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  const $quickAddPopupEl = document.querySelector('.quick-add-popup');
  if ($quickAddPopupEl && !$quickAddPopupEl.dataset.keyboardReady) {
    $quickAddPopupEl.dataset.keyboardReady = 'true';

    // matched by data-val, not by role: Swiper's a11y module rewrites the slide role
    const OPTION_SELECTOR = '.option-color, .selector-options div[data-val]';

    $quickAddPopupEl.addEventListener('keydown', function (e) {
      const option = e.target.closest(OPTION_SELECTOR);
      if (!option) return;
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      option.click();
    });

    // options are rebuilt on every open/colour change, so mirror the classes instead
    // of setting ARIA at each of the call sites that toggle them
    const syncQuickAddOptionState = function () {
      $quickAddPopupEl.querySelectorAll(OPTION_SELECTOR).forEach(function (el) {
        if (el.getAttribute('role') !== 'button') el.setAttribute('role', 'button');
        const on = el.classList.contains('active') || el.classList.contains('Active');
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (el.classList.contains('soldout')) {
          el.setAttribute('aria-disabled', 'true');
        } else {
          el.removeAttribute('aria-disabled');
        }
      });
    };
    syncQuickAddOptionState();
    new MutationObserver(syncQuickAddOptionState).observe($quickAddPopupEl, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'role']
    });
  }

  if (currentProductColor) {
    document.querySelectorAll(".quick-add-popup .option-color").forEach(colorElement => {
      const colorValue = colorElement.getAttribute("data-val").toLowerCase();

      if (colorValue === currentProductColor) {
        colorElement.classList.add("active");
      }
    });
  }

  document.querySelectorAll('.quick-add-popup .option-color').forEach(option => {
    const dataVal = option.getAttribute('data-val').toLowerCase();
    const productId = option.getAttribute('data-prod-id');
    const matchingVariants = Array.from(document.querySelectorAll('.variant')).filter(variant => {
      const variantColor = variant.getAttribute('data-variant-color').toLowerCase();
      const variantAvailable = variant.getAttribute('data-variant-available') === 'true';
      const variantProductId = variant.getAttribute('data-product-id');

      return variantColor === dataVal && variantAvailable && variantProductId === productId;
    });

    if (matchingVariants.length === 0) {
      option.style.display = 'none';
    }
  });

  const initialColorOption = document.querySelector('.quick-add-popup .option-color.active:not([style*="display: none"])') || document.querySelector('.quick-add-popup .option-color:not([style*="display: none"])');
  const initialColorValue = initialColorOption?.getAttribute('data-val');
  if (initialColorValue) {
    updateGalleryImages(initialColorValue);
  }

  document.querySelector('.colors .option-color:not([style*="display: none"])');

  //Replace select dropdowns with custom options
  if (typeof Lemonade !== 'undefined' && typeof Lemonade.productPage === 'function') {
    const $popupForm = document.querySelector('.quick-add-popup #AddToCartForm');
    if ($popupForm) {
      const $selectorWrap = $popupForm.querySelectorAll('.selector-wrapper');

      $selectorWrap.forEach(function(wrapper) {
        const $meSelect = wrapper.querySelector('.single-option-selector');
        const $meLabel = wrapper.querySelector('label');
        const meLabelText = $meLabel ? $meLabel.textContent : '';
        const $meOptions = $meSelect ? $meSelect.querySelectorAll('option') : [];
        const optionType = meLabelText.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");

        if (!$meSelect || !$meLabel) return;

        const $MeUl = document.createElement('div');
        $MeUl.className = 'selector-options';

        const $newLabel = document.createElement('div');
        $newLabel.className = 'selector-label';
        $newLabel.innerHTML = meLabelText + ':<span class="selection-label"></span>';

        $meOptions.forEach(function(option, i) {
          const meText = option.textContent;
          const meVal = option.value.replace(/["]/g, "&quot;");
          let meHandle = meText.replace(/["]/g, "&quot;").toLowerCase();
          const isCurrent = (optionType !== 'size' && i === 0) ? 'Active' : '';
          const isDisabled = option.disabled ? 'soldout' : '';

          const optionDiv = document.createElement('div');
          optionDiv.setAttribute('data-option-type', optionType);
          optionDiv.setAttribute('role', 'button');
          optionDiv.setAttribute('tabindex', '0');
          optionDiv.setAttribute('data-val', meVal);
          optionDiv.className = `${meHandle.replace(' ', '-').replace('/', '-')} ${isCurrent} ${isDisabled}`;
          optionDiv.innerHTML = `<span class="inventory-status">${meText}</span>`;

          $MeUl.appendChild(optionDiv);
        });

        $meLabel.style.display = 'none';
        $meSelect.style.display = 'none';

        wrapper.insertBefore($MeUl, wrapper.firstChild);
        wrapper.insertBefore($newLabel, wrapper.firstChild);

        // Don't set default selection label for size options
        if (optionType !== 'size') {
          const firstOption = $meOptions[0] ? $meOptions[0].textContent : '';
          const selectionLabel = wrapper.querySelector('.selector-label .selection-label');
          if (selectionLabel) {
            selectionLabel.textContent = firstOption;
          }
        }
      });
    }
  }

  // Initialize popup-specific handlers
  initPopupProductHandlers(product, selectedVariant, graphqlVariants, colorOption, updateGalleryImages, variantsInventory, isQuickAddBisEnabled, bisFormId);

  let main = document.querySelector('.colors');
  let mainOptions = main ? main.querySelectorAll('.option-color') : [];

  if (!hasSelectedImage && mainOptions.length > 0) {
    mainOptions[0].click();
  }

  // Build swiper DOM for sizes
  if (isSizesSwiperEnabled) {
    const $sizeOptions = document.querySelector('.quick-add-popup .selector-wrapper.size .selector-options');
    if ($sizeOptions && !$sizeOptions.closest('.swiper')) {
      Array.from($sizeOptions.children).forEach(function(option) {
        option.classList.add('swiper-slide');
      });
      $sizeOptions.classList.add('swiper-wrapper');
      const swiperEl = document.createElement('div');
      swiperEl.className = 'swiper quick-add-sizes-swiper';
      $sizeOptions.parentNode.insertBefore(swiperEl, $sizeOptions);
      swiperEl.appendChild($sizeOptions);
    }
  }

  // Build swiper DOM for colors
  if (isSizesSwiperEnabled) {
    const $colorsRow = document.querySelector('.quick-add-popup .colors');
    if ($colorsRow && !$colorsRow.closest('.swiper')) {
      Array.from($colorsRow.querySelectorAll('.option-color')).forEach(function(option) {
        option.classList.add('swiper-slide');
      });
      $colorsRow.classList.add('swiper-wrapper');
      const swiperEl = document.createElement('div');
      swiperEl.className = 'swiper quick-add-colors-swiper';
      $colorsRow.parentNode.insertBefore(swiperEl, $colorsRow);
      swiperEl.appendChild($colorsRow);
    }
  }

  setTimeout(() => {
    window.showModal('quick-add-popup', btn);
    btn.classList.remove('loading');

    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: { enabled: false }
      }
    };

    if (isSizesSwiperEnabled) {
      const sizeSwiperEl = document.querySelector('.quick-add-popup .quick-add-sizes-swiper');
      if (sizeSwiperEl) {
        if (window.__quickAddSizesSwiper__) {
          try { window.__quickAddSizesSwiper__.destroy(true, true); } catch(e) {}
          window.__quickAddSizesSwiper__ = null;
        }
        window.__quickAddSizesSwiper__ = new Swiper(sizeSwiperEl, swiperConfig);
      }

      const colorSwiperEl = document.querySelector('.quick-add-popup .quick-add-colors-swiper');
      if (colorSwiperEl) {
        if (window.__quickAddColorsSwiper__) {
          try { window.__quickAddColorsSwiper__.destroy(true, true); } catch(e) {}
          window.__quickAddColorsSwiper__ = null;
        }
        window.__quickAddColorsSwiper__ = new Swiper(colorSwiperEl, { ...swiperConfig, spaceBetween: 12 });
      }
    }
  }, 300);
};
/******* END QUICK ADD POPUP INIT *******/


/******* POPUP PRODUCT HANDLERS *******/
const initPopupProductHandlers = (product, selectedVariant, variants, initialColor, updateGalleryImages, variantsInventory = [], isQuickAddBisEnabled = false, bisFormId = '') => {
  const $popup = document.querySelector('.quick-add-popup');
  const $colorOptions = $popup.querySelectorAll('.option-color');
  const $sizeOptions = $popup.querySelectorAll('.selector-wrapper.size .selector-options div');
  const $valuesOptions = $popup.querySelectorAll('.selector-wrapper.values .selector-options div');
  const $variantSelect = $popup.querySelector('#productSelect');
  const $addToCartBtn = $popup.querySelector('#AddToCart');
  const $addToCartText = $popup.querySelector('#AddToCartText');
  const $quantityInput = $popup.querySelector('.Quantity');
  const $qtyMinus = $popup.querySelector('.down');
  const $qtyPlus = $popup.querySelector('.up');
  const $priceDisplay = $popup.querySelector('.quick-add-popup__pdp-price-price');
  const $form = $popup.querySelector('#AddToCartForm');

  let currentVariant = selectedVariant;
  let currentColor = initialColor?.toLowerCase();
  let currentSize = selectedVariant?.option1 || selectedVariant?.selectedOptions?.find(o => o.name === 'Size')?.value || null;
  const hasSizeOption = product.options.includes('Size');
  let sizeSelected = !hasSizeOption || product.options.length === 1;

  let sizeErrorPopupTimeout = null;

  const isVariantSelectableInPopup = (variant) => {
    if (isQuickAddBisEnabled) {
      return !!variant && isVariantVisibleByActiveMetafield(variant);
    }
    return isVariantSelectable(variant);
  };

  function ensureBisContainer() {
    const productButtons = $popup.querySelector('#product-buttons');
    const addToCartButton = $popup.querySelector('#AddToCart');
    if (!productButtons || !addToCartButton) {
      return null;
    }

    let bisContainer = $popup.querySelector('#klaviyo-bis-button-container-quick-add');
    if (!bisContainer) {
      bisContainer = document.createElement('div');
      bisContainer.id = 'klaviyo-bis-button-container-quick-add';
      bisContainer.style.display = 'none';
      bisContainer.innerHTML =
        '<button type="button" class="btn dark fill" data-klaviyo-bis-trigger>Notify me when back in stock</button>' +
        '<div class="custom-notify-form" style="display: none;">' +
          '<div class="custom-notify-form__body">' +
            '<h3 class="custom-notify-form__title">Currently Sold Out</h3>' +
            '<p class="custom-notify-form__text">Be the first one to know when the product is back in stock!</p>' +
            '<label for="quick-add-notify-email" class="custom-notify-form__label">Email</label>' +
            '<div class="custom-notify-form__input-wrapper">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M1.66699 5.83337L8.47109 10.5962C9.02207 10.9819 9.29756 11.1748 9.59721 11.2495C9.8619 11.3154 10.1387 11.3154 10.4034 11.2495C10.7031 11.1748 10.9786 10.9819 11.5296 10.5962L18.3337 5.83337M5.66699 16.6667H14.3337C15.7338 16.6667 16.4339 16.6667 16.9686 16.3942C17.439 16.1545 17.8215 15.7721 18.0612 15.3017C18.3337 14.7669 18.3337 14.0668 18.3337 12.6667V7.33337C18.3337 5.93324 18.3337 5.23318 18.0612 4.6984C17.8215 4.22799 17.439 3.84554 16.9686 3.60586C16.4339 3.33337 15.7338 3.33337 14.3337 3.33337H5.66699C4.26686 3.33337 3.5668 3.33337 3.03202 3.60586C2.56161 3.84554 2.17916 4.22799 1.93948 4.6984C1.66699 5.23318 1.66699 5.93324 1.66699 7.33337V12.6667C1.66699 14.0668 1.66699 14.7669 1.93948 15.3017C2.17916 15.7721 2.56161 16.1545 3.03202 16.3942C3.5668 16.6667 4.26686 16.6667 5.66699 16.6667Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '<input type="email" id="quick-add-notify-email" class="custom-notify-form__email" placeholder="name@domain.com">' +
            '</div>' +
            '<button type="button" class="custom-notify-form__submit btn dark fill">Notify Me!</button>' +
          '</div>' +
          '<div class="custom-notify-form__feedback">' +
            '<button type="button" class="custom-notify-form__close" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
            '<h3 class="custom-notify-form__feedback-title">Thank you!</h3>' +
            '<p class="custom-notify-form__feedback-text">We\'ll notify <span class="custom-notify-form__feedback-email"></span> if this item is available again.</p>' +
          '</div>' +
        '</div>';
      addToCartButton.insertAdjacentElement('afterend', bisContainer);
    }

    const bisTrigger = bisContainer.querySelector('[data-klaviyo-bis-trigger]');
    const notifyForm = bisContainer.querySelector('.custom-notify-form');
    if (bisTrigger && notifyForm && !bisTrigger.dataset.bisBound && window.initKlaviyoNotifyForm) {
      bisTrigger.dataset.bisBound = 'true';
      bisContainer._notifyApi = window.initKlaviyoNotifyForm({
        trigger: bisTrigger,
        form: notifyForm,
        getVariantId: function () { return String(currentVariant.id).split('/').pop(); }
      });
    }

    return bisContainer;
  }

  function setBisVisibility(visible) {
    const bisContainer = ensureBisContainer();
    if (!bisContainer) return;
    bisContainer.style.display = visible ? '' : 'none';
    bisContainer.classList.toggle('is-active', !!visible);

    // Reset the inline form back to its trigger state when hidden so a
    // re-opened / re-selected variant always starts clean.
    if (!visible && bisContainer._notifyApi) {
      bisContainer._notifyApi.reset();
    }
  }

  ensureBisContainer();

  function triggerSizeError() {
    const $sizeWrapper = $popup.querySelector('.selector-wrapper.size');
    if (!$sizeWrapper) return;
    const $sizeErrorMsg = $form ? $form.querySelector('.size-error-message') : null;
    if ($sizeErrorMsg) $sizeErrorMsg.style.display = '';
    $sizeWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (sizeErrorPopupTimeout) {
      clearTimeout(sizeErrorPopupTimeout);
      $sizeWrapper.classList.remove('size-error');
      void $sizeWrapper.offsetWidth;
    }
    $sizeWrapper.classList.add('size-error');
    sizeErrorPopupTimeout = setTimeout(() => {
      $sizeWrapper.classList.remove('size-error');
      sizeErrorPopupTimeout = null;
    }, 5000);
  }

  function clearSizeError() {
    if (sizeErrorPopupTimeout) {
      clearTimeout(sizeErrorPopupTimeout);
      sizeErrorPopupTimeout = null;
    }
    const $sizeWrapper = $popup.querySelector('.selector-wrapper.size');
    if ($sizeWrapper) $sizeWrapper.classList.remove('size-error');
    const $sizeErrorMsg = $form ? $form.querySelector('.size-error-message') : null;
    if ($sizeErrorMsg) $sizeErrorMsg.style.display = 'none';
  }

  // If product has only 1 variant and it's available, auto-select it
  if (variants.length === 1 && isVariantSelectable(variants[0])) {
    currentVariant = variants[0];
    sizeSelected = true;
    if (variants[0].selectedOptions.find(o => o.name === 'Size')?.value) {
      currentSize = variants[0].selectedOptions.find(o => o.name === 'Size')?.value;
      clearSizeError();
    }
    // Update the select value
    if ($variantSelect) {
      $variantSelect.value = variants[0].id;
    }
  }
  // Hide unavailable colors only when BIS mode is disabled
  if (!isQuickAddBisEnabled) {
    $colorOptions.forEach(option => {
      const dataVal = option.getAttribute('data-val')?.toLowerCase();
      const matchingVariants = variants.filter(variant =>
        variant.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === dataVal && isVariantSelectable(variant)
      );

      if (matchingVariants.length === 0) {
        option.style.display = 'none';
      }
    });
  }


  // Set initial active color
  if (currentColor) {
    $colorOptions.forEach(colorElement => {
      const colorValue = colorElement.getAttribute('data-val')?.toLowerCase();
      if (colorValue === currentColor) {
        colorElement.classList.add('active');
        updateColorTitle(currentColor);
      }
    });
  }

  // Update size availability based on selected color
  function updateSizeAvailability() {
    $sizeOptions.forEach(sizeBtn => {
      const size = sizeBtn.getAttribute('data-val');

      // Hide size swatches whose variant doesn't exist for the selected color at all
      // (regardless of selectability/availability).
      const variantExistsForColor = variants.some(v =>
        v.selectedOptions.find(o => o.name === 'Size')?.value === size &&
        (!currentColor || v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor)
      );

      if (!variantExistsForColor) {
        sizeBtn.style.display = 'none';
        sizeBtn.classList.add('variant-not-existing');
        if (sizeBtn.classList.contains('Active')) {
          sizeBtn.classList.remove('Active');
        }
        return;
      }

      sizeBtn.style.display = '';
      sizeBtn.classList.remove('variant-not-existing');

      // Soldout reflects real stock (availableForSale), independent of BIS mode.
      // BIS selectability is handled separately in the click handler / updateProductUI,
      // so sold-out sizes still get the soldout class even when notify-me is enabled.
      const inStockVariant = variants.find(v =>
        v.selectedOptions.find(o => o.name === 'Size')?.value === size &&
        (!currentColor || v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor) &&
        isVariantSelectable(v)
      );

      if (inStockVariant) {
        sizeBtn.classList.remove('soldout');
      } else {
        sizeBtn.classList.add('soldout');
        if (sizeBtn.classList.contains('Active')) {
          sizeBtn.classList.remove('Active');
        }
      }
    });

    // Auto-select size if only one available size for current color
    if (hasSizeOption && currentColor) {
      const availableSizes = Array.from($sizeOptions).filter(btn => !btn.classList.contains('soldout') && !btn.classList.contains('variant-not-existing'));
      if (availableSizes.length === 1 && !sizeSelected) {
        const onlySize = availableSizes[0];
        const selectedSize = onlySize.getAttribute('data-val');

        onlySize.classList.add('Active');
        currentSize = selectedSize;
        sizeSelected = true;

        const sizeLabel = $popup.querySelector('.selector-wrapper.size .selector-label .selection-label');
        if (sizeLabel) {
          sizeLabel.textContent = selectedSize;
        }

        const matchingVariant = variants.find(v =>
          v.selectedOptions.find(o => o.name === 'Size')?.value === selectedSize &&
          v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor &&
          isVariantSelectable(v)
        );

        if (matchingVariant) {
          $variantSelect.value = matchingVariant.id;
          currentVariant = matchingVariant;
          updateProductUI(matchingVariant);
          clearSizeError();
        }
      }
    }
  }

  // Size option click handler
  $sizeOptions.forEach(sizeBtn => {
    sizeBtn.addEventListener('click', function() {
      if (!isQuickAddBisEnabled && this.classList.contains('soldout')) return;

      clearSizeError();

      const selectedSize = this.getAttribute('data-val');

      $sizeOptions.forEach(btn => btn.classList.remove('Active'));
      this.classList.add('Active');

      currentSize = selectedSize;
      sizeSelected = true;

      const sizeLabel = $popup.querySelector('.selector-wrapper.size .selector-label .selection-label');
      if (sizeLabel) {
        sizeLabel.textContent = selectedSize;
      }

      const sizeSelect = $popup.querySelector('#SingleOptionSelector-0');
      if (sizeSelect) {
        sizeSelect.value = selectedSize;
      }

      const matchingVariant = variants.find(v =>
        v.selectedOptions.find(o => o.name === 'Size')?.value === selectedSize &&
        (!currentColor || v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor) &&
        isVariantSelectableInPopup(v)
      );

      if (matchingVariant) {
        $variantSelect.value = matchingVariant.id;
        currentVariant = matchingVariant;
        updateProductUI(matchingVariant);
      }

      if (sizeSelected && (!isQuickAddBisEnabled ? isVariantSelectableInPopup(currentVariant) : !!currentVariant?.availableForSale)) {
        $addToCartBtn.classList.remove('disabled');
        $addToCartBtn.disabled = false;
      }
    });
  });

  // Values option click handler
  $valuesOptions.forEach(valueBtn => {
    valueBtn.addEventListener('click', function() {
      if (!isQuickAddBisEnabled && this.classList.contains('soldout')) return;

      const selectedValue = this.getAttribute('data-val');

      $valuesOptions.forEach(btn => btn.classList.remove('Active'));
      this.classList.add('Active');

      const valuesLabel = $popup.querySelector('.selector-wrapper.values .selector-label .selection-label');
      if (valuesLabel) {
        valuesLabel.textContent = selectedValue;
      }

      const valuesSelect = $popup.querySelector('#SingleOptionSelector-values');
      if (valuesSelect) {
        valuesSelect.value = selectedValue;
      }

      const matchingVariant = variants.find(v =>
        v.selectedOptions.find(o => o.name === 'Values')?.value === selectedValue &&
        (!currentColor || v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor) &&
        isVariantSelectableInPopup(v)
      );

      if (matchingVariant) {
        $variantSelect.value = matchingVariant.id;
        currentVariant = matchingVariant;
        updateProductUI(matchingVariant);
        $addToCartBtn.classList.remove('disabled');
        $addToCartBtn.disabled = false;
      }
    });
  });

  // Color option click handler
  $colorOptions.forEach(colorBtn => {
    colorBtn.addEventListener('click', function() {
      const selectedColor = this.getAttribute('data-val')?.toLowerCase();

      $colorOptions.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      updateColorTitle(selectedColor);
      currentColor = selectedColor;
      updateGalleryImages(selectedColor);
      updateSizeAvailability();

      let matchingVariant = null;

      if (hasSizeOption && currentSize) {
        matchingVariant = variants.find(v =>  v.selectedOptions.find(o => o.name === 'Size')?.value === currentSize && v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === selectedColor && isVariantSelectableInPopup(v));

        // If current size is not available with new color, reset size selection
        if (!matchingVariant) {
          currentSize = null;
          sizeSelected = false;

          $sizeOptions.forEach(btn => btn.classList.remove('Active'));

          const sizeLabel = $popup.querySelector('.selector-wrapper.size .selector-label .selection-label');
          if (sizeLabel) {
            sizeLabel.textContent = '';
          }

          // Disable button and set text to "Select A Size"
          if ($addToCartBtn) {
            $addToCartBtn.classList.add('disabled');
            $addToCartBtn.disabled = true;
            const btnText = $addToCartBtn.querySelector('.btn-text');
            if (btnText) {
              btnText.textContent = 'Select A Size';
            }
          }
        }
      }

      if (!matchingVariant) {
        matchingVariant = variants.find(v =>
          v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === selectedColor && isVariantSelectableInPopup(v)
        );
      }

      if (matchingVariant) {
        $variantSelect.value = matchingVariant.id;
        currentVariant = matchingVariant;
        updateProductUI(matchingVariant);
      }
    });
  });

  // Initial size availability update
  updateSizeAvailability();

  // Highlight a size the popup was opened with (e.g. clicked from a product card) — the
  // generic <select>-to-buttons converter above deliberately skips auto-marking any size
  // as Active (unlike color), so an incoming currentSize otherwise never gets shown as selected.
  if (hasSizeOption && currentSize && !sizeSelected) {
    const $preselectedSize = Array.from($sizeOptions).find(function (btn) {
      return btn.getAttribute('data-val') === currentSize && !btn.classList.contains('variant-not-existing') && !btn.classList.contains('soldout');
    });
    if ($preselectedSize) {
      $sizeOptions.forEach(function (btn) { btn.classList.remove('Active'); });
      $preselectedSize.classList.add('Active');
      sizeSelected = true;

      const sizeLabel = $popup.querySelector('.selector-wrapper.size .selector-label .selection-label');
      if (sizeLabel) {
        sizeLabel.textContent = currentSize;
      }
      clearSizeError();

      const matchingVariant = variants.find(v =>
        v.selectedOptions.find(o => o.name === 'Size')?.value === currentSize &&
        (!currentColor || v.selectedOptions.find(o => o.name === 'Color')?.value?.toLowerCase() === currentColor) &&
        isVariantSelectableInPopup(v)
      );
      if (matchingVariant) {
        $variantSelect.value = matchingVariant.id;
        currentVariant = matchingVariant;
      }
    }
  }

  updateProductUI(currentVariant);

  // Variant select change handler
  if ($variantSelect) {
    $variantSelect.addEventListener('change', function() {
      const variantId = parseInt(this.value);
      const variant = variants.find(v => v.id === variantId);

      if (variant) {
        currentVariant = variant;

        if (variant.selectedOptions.find(o => o.name === 'Color')?.value) {
          const variantColor = variant.selectedOptions.find(o => o.name === 'Color')?.value.toLowerCase();
          currentColor = variantColor;

          $colorOptions.forEach(btn => {
            btn.classList.remove('active');
            if (btn.getAttribute('data-val')?.toLowerCase() === variantColor) {
              btn.classList.add('active');
            }
          });

          updateColorTitle(variantColor);
        }

        updateProductUI(variant);
      }
    });
  }

  // Quantity controls
  const setQtyMinusDisabled = (disabled) => {
    if (!$qtyMinus) return;
    if (disabled) {
      $qtyMinus.setAttribute('disabled', 'disabled');
      $qtyMinus.setAttribute('aria-disabled', 'true');
    } else {
      $qtyMinus.removeAttribute('disabled');
      $qtyMinus.removeAttribute('aria-disabled');
    }
  };

  if ($qtyMinus) {
    $qtyMinus.addEventListener('click', () => {
      const currentQty = parseInt($quantityInput.value) || 1;
      if (currentQty > 1) {
        $quantityInput.value = currentQty - 1;
        if (currentQty - 1 <= 1) {
          setQtyMinusDisabled(true);
        }
      }
    });
  }

  if ($qtyPlus) {
    $qtyPlus.addEventListener('click', () => {
      const currentQty = parseInt($quantityInput.value) || 1;
      $quantityInput.value = currentQty + 1;
      setQtyMinusDisabled(false);
    });
  }

  // both controls are spans, so Enter/Space have to be wired by hand
  [$qtyMinus, $qtyPlus].forEach((btn) => {
    if (!btn) return;
    btn.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
      e.preventDefault();
      btn.click();
    });
  });

  if ($quantityInput) {
    $quantityInput.addEventListener('change', function() {
      const val = parseInt(this.value) || 1;
      this.value = Math.max(1, val);
      setQtyMinusDisabled(this.value <= 1);
    });
  }

  // Form submit
  if ($form) {
    $form.addEventListener('click', (e) => {
      if (e.target.closest('#AddToCart') && $addToCartBtn.classList.contains('disabled') && hasSizeOption && !sizeSelected) {
        triggerSizeError();
      }
    });

    $form.addEventListener('submit', async (e) => {

      e.preventDefault();

      if (hasSizeOption && !sizeSelected) {
        triggerSizeError();
        return;
      }

      if (!currentVariant || !isVariantSelectable(currentVariant)) {
        console.error('No variant selected or variant not available');
        return;
      }

      if ($variantSelect) {
        $variantSelect.value = currentVariant.id;
      }
      const quantity = parseInt($quantityInput.value) || 1;

      // Check inventory quantity including items already in cart
      const numericVariantId = Number(currentVariant.id.toString().split('/').pop());
      const variantInventory = variantsInventory.find(v => v.id === numericVariantId);
      if (variantInventory && variantInventory.inventory_quantity > 0) {
        const cartCheckResponse = await fetch('/cart.js');
        const cartData = await cartCheckResponse.json();
        const addedVariant = cartData.items.find(item => item.variant_id === numericVariantId);
        const quantityInCart = addedVariant ? addedVariant.quantity : 0;
        const availableToAdd = variantInventory.inventory_quantity - quantityInCart;

        const $cartError = $popup.querySelector('.popup__cart-error');

        if (availableToAdd <= 0) {
          if ($cartError) {
            $cartError.textContent = 'The maximum quantity of this item is already in your cart.';
            $cartError.style.display = 'block';

            setTimeout(() => {
              $cartError.style.display = 'none';
            }, 5000);
          }
          return;
        }

        if (quantity > availableToAdd) {
          if ($cartError) {
            $cartError.textContent = `Only ${availableToAdd} more available to add`;
            $cartError.style.display = 'block';

            setTimeout(() => {
              $cartError.style.display = 'none';
            }, 5000);
          }
          $quantityInput.value = availableToAdd;
          return;
        }
      }

      $addToCartBtn.disabled = true;
      $addToCartBtn.classList.add('btn--loading');
      $addToCartText.style.display = 'none';
      const $addToCartAdding = $popup.querySelector('#AddToCartAdding');
      if ($addToCartAdding) $addToCartAdding.style.display = 'inline';

      try {
        // Add main product to cart
        const lvComparePrice = (currentVariant.compareAtPrice && currentVariant.compareAtPrice.amount != null)
          ? String(Math.round(parseFloat(currentVariant.compareAtPrice.amount) * 100))
          : '';
        const lvAddBody = {
          id: Number(currentVariant.id.split('/').pop()),
          quantity: quantity
        };
        if (lvComparePrice) {
          lvAddBody.properties = { '_compare-price': lvComparePrice };
        }
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(lvAddBody)
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Error adding to cart');
        }

        if (typeof liquidVars !== 'undefined' && liquidVars.oneTreeProdID && liquidVars.oneTreeProdHandle) {
          const treeResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: parseInt(liquidVars.oneTreeProdID),
              quantity: quantity
            })
          });
        }

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        if (typeof Utilities !== 'undefined' && typeof Utilities.renderCartFlyout === 'function') {

          const showMobilePopup = $popup.dataset.showAddedPopup === 'true';
          const isMobileDevice = Utilities.isMobileDevice && Utilities.isMobileDevice();

          if (isMobileDevice && !document.querySelector("#CartFlyout")?.classList.contains("Show") && showMobilePopup && typeof Utilities.handleSidecartPopUp === 'function') {
            Utilities.handleSidecartPopUp(product.title);
            Utilities.renderCartFlyout(cart, false);
          } else {
            Utilities.renderCartFlyout(cart, true);
          }
        }

        const totalCurrency = document.querySelector("#Subtotal");
        if (totalCurrency && typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof moneyFormat !== 'undefined') {
          totalCurrency.innerHTML = typeof Utilities !== 'undefined' && Utilities.cartTotalHtml
            ? Utilities.cartTotalHtml(cart)
            : `TOTAL <span class="money">${Shopify.formatMoney(cart.total_price, moneyFormat)}</span>`;
        }

        window.hideModal('quick-add-popup');

      } catch (error) {
        console.error('Error in form submit:', error);
        $addToCartBtn.disabled = false;
        $addToCartBtn.classList.remove('btn--loading');
        $addToCartText.style.display = '';
        if ($addToCartAdding) $addToCartAdding.style.display = 'none';
      }
    });

  }

  // Helper functions
  function updateColorTitle(color) {
    if (!color) return;

    const colorValuesElement = document.querySelector('[data-colors-list]');
    if (!colorValuesElement) return;

    let colorValues;
    try {
      colorValues = JSON.parse(colorValuesElement.textContent);
    } catch {
      return;
    }

    const mappedColor = colorValues[color.toUpperCase()];
    const coreElement = document.querySelector('.color-title-wrapper');
    const limitedElement = document.querySelector('.color-limited span.limited-color-title');

    if (mappedColor && mappedColor.trim()) {  
      if (coreElement){
        coreElement.textContent = "Color: " + mappedColor;  
      } 
      if (limitedElement) {
        limitedElement.textContent = '';
      }
    } else {
      if (limitedElement) limitedElement.textContent = ' ';
    }  
  }

  function updateProductUI(variant) {
    if (!variant) return;

    if ($priceDisplay) {
      $priceDisplay.textContent = formatPrice(variant.price.amount);
    }

    // Get current compare price element (it might have been created dynamically)
    const currentComparePrice = $popup.querySelector('.quick-add-popup__pdp-price-compare-at');
    if (+variant.compareAtPrice?.amount > +variant.price.amount) {
      if (!currentComparePrice) {
        const priceContainer = $popup.querySelector('.quick-add-popup__pdp-price');
        if (priceContainer) {
          const compareEl = document.createElement('s');
          compareEl.className = 'quick-add-popup__pdp-price-compare-at money';
          compareEl.textContent = formatPrice(variant.compareAtPrice?.amount);
          priceContainer.appendChild(compareEl);
        }
      } else {
        currentComparePrice.textContent = formatPrice(variant.compareAtPrice?.amount);
        currentComparePrice.style.display = '';
      }
    } else {
      if (currentComparePrice) {
        currentComparePrice.style.display = 'none';
      }
    }

    if ($addToCartBtn) {
      const hasSizeOption = product.options.some(opt => opt.toLowerCase() === 'size');
      const canPurchase = isVariantSelectable(variant);
      const shouldShowBis = isQuickAddBisEnabled && !variant.availableForSale && isVariantVisibleByActiveMetafield(variant);

      if (canPurchase) {
        if (hasSizeOption && !sizeSelected) {
          $addToCartBtn.classList.add('disabled');
          $addToCartText.textContent = 'Select A Size';
          setBisVisibility(false);
        } else {
          $addToCartBtn.classList.remove('disabled');
          $addToCartText.textContent = 'Add to Cart';
          setBisVisibility(false);
        }
      } else {
        $addToCartBtn.classList.add('disabled');
        $addToCartText.textContent = 'Sold Out';
        setBisVisibility(shouldShowBis);
      }
    }
  }
};
/******* END POPUP PRODUCT HANDLERS *******/


/******* EVENTS *******/
if(document.querySelector('.complete-the-look__content')){
  document.querySelector('.complete-the-look__content').addEventListener('click', (e) => {
    if (!e.target) return;
    const btn = e.target.closest('.item-quick-add__button');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      quickAddPopupInit(btn);
    
    }
  })
}

if(document.querySelector('.collection-wrapper')){
  document.querySelector('.collection-wrapper').addEventListener('click', (e) => {
    if (!e.target) return;
    const btn = e.target.closest('.item-quick-add__button');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      quickAddPopupInit(btn);
    
    }
  })
}

/******* END EVENTS *******/

window.quickAddPopupInit = quickAddPopupInit;
}
